import type { RouteRecordRaw } from 'vue-router'
import PublicPortalPage from '@/modules/portal/pages/PublicPortalPage.vue'

export const portalRoutes: RouteRecordRaw[] = [
  {
    path: '/portal/:portalLinkToken',
    name: 'portal',
    component: PublicPortalPage,
    meta: {
      isPublic: true,
      layout: 'full-screen',
    },
  },
]
